export default __webpack_public_path__ + "static/media/afshar-jokar.1d7fab5b.png";